module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/partner-four-ed75115ece4f6796c9147e3038727855.png";